import { Link } from 'react-router-dom';

export default function Privacy() {
  return (
    <div className="max-w-(--container-xs) h-screen mx-auto flex flex-col bg-white pt-safe sm:rounded-md sm:border sm:pt-0">
      <div className="flex-1 overflow-y-auto overflow-x-hidden">
        <div className="px-5 py-8 pb-safe">
        <nav className="mb-8 text-sm">
          <Link to="/sign-in" className="text-stone-600 underline underline-offset-4 hover:text-stone-900">
            ← ログイン画面に戻る
          </Link>
        </nav>

        <article className="space-y-8 text-stone-800">
          <header className="space-y-2">
            <h1 className="text-2xl font-bold">プライバシーポリシー</h1>
            <p className="text-sm leading-relaxed text-stone-600">
              株式会社サクラグループHOLDINGS.（以下「当社」）は、当社が運営する業務支援サービス「SAKURA GROUP HOLDINGS APP」（以下「本サービス」。管理画面およびホステス向けアプリケーションからなります）における個人情報の取扱いについて、以下のとおり定めます。
            </p>
          </header>

          <section className="space-y-3">
            <h2 className="text-lg font-semibold">1. 事業者情報</h2>
            <ul className="list-disc space-y-1 pl-5 text-sm leading-relaxed">
              <li>名称: 株式会社サクラグループHOLDINGS.</li>
              <li>所在地: 〒812-0025 福岡県福岡市博多区店屋町4-16 土居ビル5階</li>
              <li>代表者: 代表取締役社長 松岡 三貴</li>
              <li>個人情報取扱事業者: 株式会社サクラグループHOLDINGS.</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-lg font-semibold">2. 本サービスの利用対象</h2>
            <p className="text-sm leading-relaxed">
              本サービスは、株式会社サクラグループHOLDINGS. の管理者および当社グループに所属するホステスのうち、当社が事前に登録した者のみが利用できる業務専用ツールです。一般の方向けのサービスではありません。
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-lg font-semibold">3. 取得する情報</h2>
            <p className="text-sm leading-relaxed">本サービスは、利用にあたり以下の情報を取得します。</p>
            <ol className="list-decimal space-y-3 pl-5 text-sm leading-relaxed">
              <li>
                Google アカウントを通じて取得する情報
                <ul className="mt-1 list-disc space-y-1 pl-5">
                  <li>メールアドレス</li>
                  <li>氏名</li>
                  <li>プロフィール画像</li>
                </ul>
                <p className="mt-2 text-stone-600">
                  Google から取得する情報は OAuth スコープ <code className="rounded bg-stone-200 px-1">openid</code> /{' '}
                  <code className="rounded bg-stone-200 px-1">email</code> /{' '}
                  <code className="rounded bg-stone-200 px-1">profile</code> の範囲に限り、本サービスへのログイン認証および本人確認以外の目的には利用せず、第三者に販売しません。
                </p>
              </li>
              <li>
                本サービス上で本人が入力・記録する業務情報
                <ul className="mt-1 list-disc space-y-1 pl-5">
                  <li>顧客情報、業務記録、業務連絡その他本サービスの運営に必要な情報</li>
                </ul>
              </li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-lg font-semibold">4. 利用目的</h2>
            <p className="text-sm leading-relaxed">取得した情報は、以下の目的でのみ利用します。</p>
            <ol className="list-decimal space-y-1 pl-5 text-sm leading-relaxed">
              <li>本サービスへのログイン認証および本人確認</li>
              <li>当社グループ内部の業務管理（顧客管理、業務記録の管理、連絡等）</li>
              <li>本サービスの不具合対応および運用上必要な問い合わせ対応</li>
            </ol>
          </section>

          <section className="space-y-3">
            <h2 className="text-lg font-semibold">5. 第三者提供</h2>
            <p className="text-sm leading-relaxed">
              法令に基づく場合を除き、取得した情報を第三者に提供することはありません。
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-lg font-semibold">6. 業務委託</h2>
            <p className="text-sm leading-relaxed">
              本サービスの運営にあたり、以下の事業者に業務の一部を委託しています。
            </p>
            <ul className="list-disc space-y-1 pl-5 text-sm leading-relaxed">
              <li>Google LLC（OAuth 認証基盤）</li>
              <li>Supabase, Inc.（認証・データベース基盤）</li>
              <li>株式会社 BRICKHOUSE（本サービスの開発および運用保守）</li>
            </ul>
            <p className="text-sm leading-relaxed">
              委託先の一部は日本国外（米国）に所在しますが、個人情報を適切に取り扱うよう必要かつ適切な監督を行い、本サービスの運営目的を超える独自利用は認めません。
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-lg font-semibold">7. 保管期間</h2>
            <p className="text-sm leading-relaxed">
              取得した情報は、本サービスの運営に必要な期間保管します。利用者が本サービスの利用を終了した場合、または本人から削除の請求があった場合は、法令上の保管義務がある情報を除き、遅滞なく削除または利用停止の措置を行います。
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-lg font-semibold">8. 安全管理措置</h2>
            <p className="text-sm leading-relaxed">
              取得した情報の漏えい、滅失または毀損の防止その他の安全管理のために、アクセス制御、通信の暗号化、委託先管理など必要な措置を講じます。
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-lg font-semibold">9. 開示・訂正・削除の請求、お問い合わせ</h2>
            <p className="text-sm leading-relaxed">
              本ポリシーに関するお問い合わせ、および保有個人データの開示、内容の訂正・追加・削除、利用停止・消去・第三者提供の停止のご請求は、以下の窓口までメールにてご連絡ください。
            </p>
            <ul className="list-disc space-y-1 pl-5 text-sm leading-relaxed">
              <li>受付窓口: 株式会社 BRICKHOUSE（当社委託先）</li>
              <li>
                メールアドレス:{' '}
                <a href="mailto:9232@brickhouse.co.jp" className="underline underline-offset-4">
                  9232@brickhouse.co.jp
                </a>
              </li>
            </ul>
            <p className="text-sm leading-relaxed">
              ご請求にあたっては、ご本人であることを確認するため、当社にご登録のメールアドレスからのご連絡をお願いいたします。内容を確認のうえ、合理的な期間内にメールにて回答いたします。
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-lg font-semibold">10. 改定について</h2>
            <p className="text-sm leading-relaxed">
              本ポリシーの内容は、必要に応じて改定することがあります。重要な変更を行う場合は本サービス上で周知します。
            </p>
          </section>

          <footer className="border-t border-stone-200 pt-6 text-sm text-stone-600">
            <p>制定日: 2026年4月13日</p>
            <p>最終改定日: 2026年4月13日</p>
          </footer>
        </article>
        </div>
      </div>
    </div>
  );
}
